"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  margin-top: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 700;\n  margin-right: 20px;\n  display: inline-block;\n  margin-bottom: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n\n  @media (max-width: 767px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AlertGrid = _styledComponents.default.div.withConfig({
  displayName: "PromotionBanner__AlertGrid",
  componentId: "sc-1kbztyt-0"
})(_templateObject());

var AlertTitle = _styledComponents.default.h5.withConfig({
  displayName: "PromotionBanner__AlertTitle",
  componentId: "sc-1kbztyt-1"
})(_templateObject2());

var AlertDescription = _styledComponents.default.div.withConfig({
  displayName: "PromotionBanner__AlertDescription",
  componentId: "sc-1kbztyt-2"
})(_templateObject3());

var PromotionBanner = function PromotionBanner(_ref) {
  var promotion = _ref.promotion,
      title = _ref.title,
      description = _ref.description,
      cta = _ref.cta,
      dataSelenium = _ref.dataSelenium,
      _ref$shouldShow = _ref.shouldShow,
      shouldShow = _ref$shouldShow === void 0 ? true : _ref$shouldShow,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["promotion", "title", "description", "cta", "dataSelenium", "shouldShow"]);
  (0, _react.useEffect)(function () {
    if (shouldShow) {
      var name = promotion.toLowerCase() + " promotion banner";
      (0, _getUsageTracker.default)().track('bannerInteraction', {
        name: name
      });
    }
  }, []);
  return shouldShow && _react.default.createElement(_UIAlert.default, (0, _extends2.default)({
    "data-selenium": dataSelenium,
    type: "info"
  }, rest), _react.default.createElement(AlertGrid, {
    style: cta ? {
      gridColumnGap: '16px',
      gridRowGap: '16px'
    } : {}
  }, _react.default.createElement("div", null, _react.default.createElement(AlertTitle, null, title), _react.default.createElement(AlertDescription, null, description)), cta && _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
    href: cta.url,
    use: "tertiary",
    size: "small",
    style: {
      width: '100%'
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: cta.message
  })))));
};

PromotionBanner.propTypes = {
  promotion: _propTypes.default.string.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  cta: _propTypes.default.shape({
    message: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  dataSelenium: _propTypes.default.string,
  shouldShow: _propTypes.default.bool
};
var _default = PromotionBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/PromotionBanner.js
// module id = 338
// module chunks = 5 6